/**
 * AUTO-GENERATED — do not edit by hand.
 *
 * Source: public/models/*.meta.json
 * Generator: scripts/bundle-sidecars.mjs
 *
 * Run `npm run assets:bundle-sidecars` to regenerate after editing a
 * sidecar in public/models/. Bundled sidecars ship inside the npm package
 * so the viewer renders correctly without a matching CDN mirror.
 *
 * Module count: 27
 * Mover count:  4
 * Tool count:   2
 * Rail count:   8
 */

import type {
  ModuleSidecar,
  MoverSidecar,
  MoverToolSidecar,
  RailSidecar,
} from './SidecarLoader.js';
import type {
  ModuleType3D,
  MoverToolType3D,
  MoverType3D,
  RailType3D,
} from '../types.js';

/**
 * Built-in module sidecars. Generated from public/models/*.meta.json.
 * Identity-corrected entries are intentionally retained so the lookup
 * still resolves to a sidecar object (consumers can rely on truthy
 * results without a 404 fallback dance).
 */
export const BUILTIN_MODULE_SIDECARS: Readonly<
  Partial<Record<ModuleType3D, ModuleSidecar>>
> = Object.freeze({
  "AT2000_0233": {
    "moduleType": "AT2000_0233",
    "glbByRailSystem": {
      "Beckhoff": "AT2000-0233.glb"
    },
    "originCorrection": {
      "translateMm": [
        233,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 233,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -96,
        -13.5000000000001
      ],
      "max": [
        17.549999999999915,
        1.18329135783152e-29,
        233.3
      ]
    }
  },
  "AT2000_0249": {
    "moduleType": "AT2000_0249",
    "glbByRailSystem": {
      "Beckhoff": "AT2000-0249.glb"
    },
    "originCorrection": {
      "translateMm": [
        249,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 249,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -96,
        0
      ],
      "max": [
        17.549999999999915,
        0,
        249
      ]
    }
  },
  "AT2000_0250": {
    "moduleType": "AT2000_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2000-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        250,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -96,
        -13.5000000000001
      ],
      "max": [
        17.549999999999915,
        0,
        250
      ]
    }
  },
  "AT2001_0250": {
    "moduleType": "AT2001_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2001-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        250,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -122.35567697317887,
        0
      ],
      "max": [
        17.549999999999915,
        0,
        250
      ]
    }
  },
  "AT2002_0249_ZX2002_0001": {
    "moduleType": "AT2002_0249_ZX2002_0001",
    "glbByRailSystem": {
      "Beckhoff": "AT2002-0249-ZX2002-0001.glb"
    },
    "originCorrection": {
      "translateMm": [
        249,
        19.5,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 249,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -55.47512492230701,
        -140.43398400853,
        0
      ],
      "max": [
        19.0498750776926,
        0,
        249
      ]
    }
  },
  "AT2002_0250": {
    "moduleType": "AT2002_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2002-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        346,
        -76.5,
        -34
      ],
      "rotationDegEuler": [
        -90,
        180,
        90
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -53.1496800886791,
        -346,
        -95.9999999999999
      ],
      "max": [
        21.375319911320506,
        -95.9999999999999,
        44.4339840085297
      ]
    }
  },
  "AT2020_0250": {
    "moduleType": "AT2020_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2020-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -636.6198,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 22.5,
    "approximateBoundsMm": {
      "min": [
        -8.5265128291212e-13,
        517.945133211544,
        -22.55
      ],
      "max": [
        251.27750824841,
        656.619772367581,
        17.55
      ]
    }
  },
  "AT2021_0250": {
    "moduleType": "AT2021_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2021-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -636.6198,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 22.5,
    "approximateBoundsMm": {
      "min": [
        -8.5265128291212e-13,
        496.745254405928,
        -22.55
      ],
      "max": [
        251.27750824841,
        656.619772367581,
        17.55
      ]
    }
  },
  "AT2025_0250": {
    "moduleType": "AT2025_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2025-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        636.5,
        0
      ],
      "rotationDegEuler": [
        180,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": -22.5,
    "approximateBoundsMm": {
      "min": [
        -1.77635683940025e-13,
        569.682387032176,
        -17.55
      ],
      "max": [
        281.802589752422,
        712.61977236758,
        22.55
      ]
    }
  },
  "AT2026_0250": {
    "moduleType": "AT2026_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2026-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        636.5,
        0
      ],
      "rotationDegEuler": [
        180,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": -22.5,
    "approximateBoundsMm": {
      "min": [
        -1.77635683940025e-13,
        569.682387032176,
        -18.7
      ],
      "max": [
        272.707780460855,
        712.61977236758,
        23.7
      ]
    }
  },
  "AT2040_0250": {
    "moduleType": "AT2040_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2040-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -318.3099,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 45,
    "approximateBoundsMm": {
      "min": [
        -3.19744231092045e-13,
        168.03356351737,
        -22.55
      ],
      "max": [
        239.221214663007,
        338.309886183791,
        17.55
      ]
    }
  },
  "AT2041_0250": {
    "moduleType": "AT2041_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2041-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -318.3099,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 45,
    "approximateBoundsMm": {
      "min": [
        -3.19744231092045e-13,
        160.255535677803,
        -22.55
      ],
      "max": [
        239.221214663007,
        338.309886183791,
        17.55
      ]
    }
  },
  "AT2050_0500": {
    "moduleType": "AT2050_0500",
    "glbByRailSystem": {
      "Beckhoff": "AT2050-0500.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -133,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        180
      ]
    },
    "pathType": "Free",
    "moduleLengthMm": 500,
    "endAngleDeg": 90,
    "approximateBoundsMm": {
      "min": [
        -22.55,
        -153.35062038607114,
        -13.6
      ],
      "max": [
        17.55,
        153.35,
        194.4
      ]
    }
  },
  "AT2050_0500_180": {
    "moduleType": "AT2050_0500_180",
    "glbByRailSystem": {
      "Beckhoff": "AT2050-0500.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -133,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        180
      ]
    },
    "pathType": "Free",
    "moduleLengthMm": 500,
    "endAngleDeg": 90,
    "approximateBoundsMm": {
      "min": [
        -22.55,
        -153.35062038607114,
        -13.6
      ],
      "max": [
        17.55,
        153.35,
        194.4
      ]
    }
  },
  "AT2100_0250": {
    "moduleType": "AT2100_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2100-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        250,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -96,
        -13.5000000000001
      ],
      "max": [
        29.1499999999999,
        0,
        250
      ]
    }
  },
  "AT2102_0250": {
    "moduleType": "AT2102_0250",
    "glbByRailSystem": {
      "Beckhoff": "AT2102-0250.glb"
    },
    "originCorrection": {
      "translateMm": [
        250,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -55.47512492230701,
        -140.43398400853,
        0
      ],
      "max": [
        29.15,
        0,
        250
      ]
    }
  },
  "AT2200_0500": {
    "moduleType": "AT2200_0500",
    "glbByRailSystem": {
      "Beckhoff": "AT2200-0500.glb"
    },
    "originCorrection": {
      "translateMm": [
        500,
        19.5,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 500,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -22.550000000000015,
        -96,
        -13.5000000000001
      ],
      "max": [
        17.549999999999915,
        0,
        500
      ]
    }
  },
  "AT2202_0500": {
    "moduleType": "AT2202_0500",
    "glbByRailSystem": {
      "Beckhoff": "AT2202-0500.glb"
    },
    "originCorrection": {
      "translateMm": [
        500,
        19.5,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 500,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -55.578940058985644,
        -140.254,
        0
      ],
      "max": [
        18.9499999999756,
        0,
        500
      ]
    }
  },
  "ATH2000_0250": {
    "moduleType": "ATH2000_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2000-0250.glb",
      "HepcoGfx": "ATH2000-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        125,
        -72,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -162.5,
        -27.5,
        -1.11022302462516e-15
      ],
      "max": [
        125,
        17,
        96
      ]
    }
  },
  "ATH2001_0250": {
    "moduleType": "ATH2001_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2001-0250.glb",
      "HepcoGfx": "ATH2001-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        125,
        -72,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -162.5,
        -177,
        -1.11022302462516e-15
      ],
      "max": [
        125,
        17,
        96
      ]
    }
  },
  "ATH2002_0250": {
    "moduleType": "ATH2002_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2002-0250.glb",
      "HepcoGfx": "ATH2002-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        125,
        -72,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        0
      ]
    },
    "pathType": "Straight",
    "moduleLengthMm": 250,
    "endAngleDeg": 0,
    "approximateBoundsMm": {
      "min": [
        -162.5,
        -64,
        -113.1356458286208
      ],
      "max": [
        125,
        17,
        96
      ]
    }
  },
  "ATH2020_0250": {
    "moduleType": "ATH2020_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2020-0250.glb",
      "HepcoGfx": "ATH2020-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -636.5,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        -90
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 22.5,
    "approximateBoundsMm": {
      "min": [
        -17,
        -37.5,
        521.64065134159
      ],
      "max": [
        27.5,
        252.80824197787,
        660.619772367582
      ]
    }
  },
  "ATH2040_0250": {
    "moduleType": "ATH2040_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2040-0250.glb",
      "HepcoGfx": "ATH2040-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -318.5,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        -90
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 45,
    "approximateBoundsMm": {
      "min": [
        -17,
        -37.5000000000001,
        174.167390793845
      ],
      "max": [
        27.5,
        242.049641787754,
        342.309886183791
      ]
    }
  },
  "ATH2041_0250": {
    "moduleType": "ATH2041_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2041-0250.glb",
      "HepcoGfx": "ATH2041-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -318.5,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        -90
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 45,
    "approximateBoundsMm": {
      "min": [
        -17,
        -37.5000000000001,
        174.167390793845
      ],
      "max": [
        177,
        242.049641787754,
        342.309886183791
      ]
    }
  },
  "ATH2042_0250": {
    "moduleType": "ATH2042_0250",
    "glbByRailSystem": {
      "Beckhoff": "ATH2042-0250.glb",
      "HepcoGfx": "ATH2042-0250-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -318.5,
        0
      ],
      "rotationDegEuler": [
        -90,
        0,
        -90
      ]
    },
    "pathType": "Curve",
    "moduleLengthMm": 250,
    "endAngleDeg": 45,
    "approximateBoundsMm": {
      "min": [
        -17,
        -37.5000000000001,
        133.1742403551702
      ],
      "max": [
        64,
        242.049641787754,
        342.309886183791
      ]
    }
  },
  "ATH2050_0500": {
    "moduleType": "ATH2050_0500",
    "glbByRailSystem": {
      "Beckhoff": "ATH2050-0500.glb",
      "HepcoGfx": "ATH2050-0500-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -133.5,
        0
      ],
      "rotationDegEuler": [
        0,
        180,
        90
      ]
    },
    "pathType": "Free",
    "moduleLengthMm": 500,
    "endAngleDeg": 90,
    "approximateBoundsMm": {
      "min": [
        -157.350063377838,
        -37.6000000000002,
        -27.500000000000004
      ],
      "max": [
        157.350063377838,
        198.10008108029504,
        22.500000000000014
      ]
    }
  },
  "ATH2050_0500_180": {
    "moduleType": "ATH2050_0500_180",
    "glbByRailSystem": {
      "Beckhoff": "ATH2050-0500.glb",
      "HepcoGfx": "ATH2050-0500-0002.glb"
    },
    "originCorrection": {
      "translateMm": [
        0,
        -133.5,
        0
      ],
      "rotationDegEuler": [
        0,
        180,
        90
      ]
    },
    "pathType": "Free",
    "moduleLengthMm": 500,
    "endAngleDeg": 90,
    "approximateBoundsMm": {
      "min": [
        -157.350063377838,
        -37.6000000000002,
        -27.500000000000004
      ],
      "max": [
        157.350063377838,
        198.10008108029504,
        22.500000000000014
      ]
    }
  }
} as Partial<
  Record<ModuleType3D, ModuleSidecar>
>);

/** Built-in mover sidecars. Generated from public/models/*.meta.json. */
export const BUILTIN_MOVER_SIDECARS: Readonly<
  Partial<Record<MoverType3D, MoverSidecar>>
> = Object.freeze({
  "AT9014_0055": {
    "moverType": "AT9014_0055",
    "glb": "AT9014-0055-0550.glb",
    "originCorrection": {
      "translateMm": [
        0,
        38.5,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        0
      ]
    },
    "magnetPlateCenterMm": [
      0,
      0,
      0
    ],
    "pathLengthMm": 55,
    "approximateBoundsMm": {
      "min": [
        -35.0000000000003,
        -93.35,
        -27.5
      ],
      "max": [
        35,
        31.5,
        27.5
      ]
    }
  },
  "AT9014_0070": {
    "moverType": "AT9014_0070",
    "glb": "AT9014-0070-0550.glb",
    "originCorrection": {
      "translateMm": [
        0,
        41,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        0
      ]
    },
    "magnetPlateCenterMm": [
      0,
      0,
      0
    ],
    "pathLengthMm": 70,
    "approximateBoundsMm": {
      "min": [
        -37.0000000000002,
        -93.3499999999993,
        -35.00000000000011
      ],
      "max": [
        37.0000000000002,
        32.5000000000003,
        35.00000000000032
      ]
    }
  },
  "ATH9011_0075": {
    "moverType": "ATH9011_0075",
    "glb": "ATH9011-0075-0550.glb",
    "originCorrection": {
      "translateMm": [
        0,
        49.5,
        0
      ],
      "rotationDegEuler": [
        0,
        -90,
        0
      ]
    },
    "magnetPlateCenterMm": [
      0,
      0,
      0
    ],
    "pathLengthMm": 75,
    "approximateBoundsMm": {
      "min": [
        -46,
        -70.45,
        -37.48754345581859
      ],
      "max": [
        46,
        41.2,
        37.48754345581859
      ]
    }
  },
  "Hepco_GFX2_1TC_S25": {
    "moverType": "Hepco_GFX2_1TC_S25",
    "glb": "GFX2-1TC-S25.glb",
    "originCorrection": {
      "translateMm": [
        0,
        40,
        30
      ],
      "rotationDegEuler": [
        -90,
        0,
        0
      ]
    },
    "magnetPlateCenterMm": [
      0,
      0,
      0
    ],
    "pathLengthMm": 100,
    "approximateBoundsMm": {
      "min": [
        -41.6,
        0,
        -106.44
      ],
      "max": [
        41.6,
        85.5,
        0
      ]
    }
  }
} as Partial<
  Record<MoverType3D, MoverSidecar>
>);

/** Built-in tool sidecars. Generated from public/models/*.tool.meta.json. */
export const BUILTIN_TOOL_SIDECARS: Readonly<
  Partial<Record<MoverToolType3D, MoverToolSidecar>>
> = Object.freeze({
  "AT8200_1000_0100": {
    "toolType": "AT8200_1000_0100",
    "glbUrl": "AT8200-1000-0100.glb",
    "originCorrection": {
      "translateMm": [
        0,
        0,
        20
      ],
      "rotationDegEuler": [
        0,
        0,
        90
      ]
    },
    "defaultOffsetMm": [
      0,
      0,
      30
    ],
    "approximateBoundsMm": {
      "min": [
        -85.1,
        -31.85,
        -23.000000000000004
      ],
      "max": [
        66.2,
        30.15000000000001,
        19.5499999999999
      ]
    },
    "label": "AT8200-1000-0100"
  },
  "AT8200_2000_0100": {
    "toolType": "AT8200_2000_0100",
    "glbUrl": "AT8200-2000-0100.glb",
    "originCorrection": {
      "translateMm": [
        0,
        0,
        20
      ],
      "rotationDegEuler": [
        0,
        0,
        90
      ]
    },
    "defaultOffsetMm": [
      0,
      0,
      30
    ],
    "approximateBoundsMm": {
      "min": [
        -97.1,
        -34.50000000000002,
        -4.800000000000022
      ],
      "max": [
        21,
        34.5,
        36.85
      ]
    },
    "label": "AT8200-2000-0100"
  }
} as Partial<
  Record<MoverToolType3D, MoverToolSidecar>
>);

/** Built-in rail sidecars. Generated from public/models/*.rail.meta.json. */
export const BUILTIN_RAIL_SIDECARS: Readonly<
  Partial<Record<RailType3D, RailSidecar>>
> = Object.freeze({
  "AT9000_0249": {
    "railType": "AT9000_0249",
    "glb": "AT9000-0249-rail.glb",
    "originCorrection": {
      "translateMm": [
        -25.5,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -11.1,
        0,
        0
      ],
      "max": [
        11.1,
        39,
        274.5
      ]
    }
  },
  "AT9000_0250": {
    "railType": "AT9000_0250",
    "glb": "AT9000-0250-rail.glb",
    "originCorrection": {
      "translateMm": [
        -26,
        20,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -11.1,
        0,
        0
      ],
      "max": [
        11.1,
        39,
        276.1
      ]
    }
  },
  "AT9000_0500": {
    "railType": "AT9000_0500",
    "glb": "AT9000-0500-rail.glb",
    "originCorrection": {
      "translateMm": [
        -26,
        19.5,
        0
      ],
      "rotationDegEuler": [
        0,
        90,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -11.1,
        0,
        0
      ],
      "max": [
        11.1,
        39,
        526.1
      ]
    }
  },
  "AT9020_1250": {
    "railType": "AT9020_1250",
    "glb": "AT9020-1250-rail.glb",
    "originCorrection": {
      "translateMm": [
        560,
        -559.5,
        27
      ],
      "rotationDegEuler": [
        180,
        0,
        90
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -618.58,
        -135.7,
        15.96
      ],
      "max": [
        324.44,
        588.62,
        38.16
      ]
    }
  },
  "AT9025_1466": {
    "railType": "AT9025_1466",
    "glb": "AT9025-1466-rail.glb",
    "originCorrection": {
      "translateMm": [
        0,
        0,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -624.05,
        -246.57,
        86.39
      ],
      "max": [
        223.27,
        632.05,
        108.59
      ]
    }
  },
  "AT9040_0750": {
    "railType": "AT9040_0750",
    "glb": "AT9040-0750-rail.glb",
    "originCorrection": {
      "translateMm": [
        0,
        0,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -377.31,
        -19.5,
        -14.6
      ],
      "max": [
        247.4,
        386.51,
        7.6
      ]
    }
  },
  "AT9050_0500": {
    "railType": "AT9050_0500",
    "glb": "AT9050-0500-rail.glb",
    "originCorrection": {
      "translateMm": [
        0,
        -133,
        0
      ],
      "rotationDegEuler": [
        0,
        0,
        0
      ]
    },
    "approximateBoundsMm": {
      "min": [
        -28.8,
        -192.35,
        -11.1
      ],
      "max": [
        234.3,
        192.35,
        11.1
      ]
    }
  },
  "HepcoGfx": {
    "railType": "HepcoGfx",
    "kind": "procedural-rail-profile",
    "profile": {
      "baseplateWidthMm": 134.45,
      "baseplateThicknessMm": 30,
      "baseplateTopZMm": -45,
      "railWidthMm": 44,
      "railHeightMm": 15,
      "railTopZMm": -30,
      "spearProtrusionMm": 5,
      "spearBaseHalfHeightMm": 4,
      "undercutInsetMm": 3,
      "stackYOffsetMm": -13,
      "stackZOffsetMm": -9
    }
  }
} as Partial<
  Record<RailType3D, RailSidecar>
>);
